module.exports = __webpack_public_path__ + "img/ctrl-a-stub-up-+.7d14c77c.svg";